import { render } from "./todayTime.vue?vue&type=template&id=186f73b7&scoped=true"
import script from "./todayTime.vue?vue&type=script&lang=js"
export * from "./todayTime.vue?vue&type=script&lang=js"

import "./todayTime.vue?vue&type=style&index=0&id=186f73b7&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186f73b7"]])

export default __exports__